var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4835 6.35521L27.1265 26.9029C26.7978 28.3531 25.9405 28.714 24.7224 28.0308L18.0837 23.1388L14.8804 26.2197C14.5259 26.5742 14.2294 26.8706 13.5462 26.8706L14.0232 20.1095L26.3273 8.99135C26.8622 8.51439 26.2113 8.25014 25.4958 8.72709L10.2849 18.3048L3.73645 16.2552C2.31203 15.8105 2.28625 14.8308 4.03293 14.1476L29.6466 4.27982C30.8325 3.8351 31.8702 4.54408 31.4835 6.35521Z",
    fill: "#5F7F04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/SVG-1.72ca27ff53d347dbc53aff1ad01960fc.svg";
export { ForwardRef as ReactComponent };